<template>
  <ion-toolbar>
    <ion-buttons slot="start" v-if="
        $store.state.pages.auth.back.length ||
          stepLanguage ||
          routeName == 'profile_languages'
      ">
      <ion-button class="button_back" @click="goBack">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="main_wrapper ion-padding">
    <div class="container">
      <div class="auth-header">
        <div class="auth-heading">
          <h1>Language</h1>
        </div>
        <div class="brand-icon">
          <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" />
        </div>
      </div>
      <el-form class="full_page" :model="formsData.userForm" :rules="formsData.userForm.rules"
        :ref="(el) => (formsData.userForm.ref = el)" :label-position="'top'"
        @submit.prevent="save('userForm', stepLanguage ? true : false)">
        <template v-if="!stepLanguage">
          <div class="form_text">
            <div class="text">
              Are you fluent in a language other than English?
            </div>
          </div>
          <div class="button_submit mb0 buttons-group">
            <el-button type="blue_light" @click="save('userForm', false)">
              No
            </el-button>
            <el-button type="blue" @click="nextStep">
              Yes
            </el-button>
          </div>
        </template>
        <template v-else>
          <div class="form_text">
            <div class="text">
              Please select the languages you know
            </div>
          </div>
          <el-form-item class="no-scroll" prop="languages">
            <div class="select_wrapper" v-for="(select, i) in formsData.userForm.languages.selectValue" :key="i">
              <VueMultiselect v-model="formsData.userForm.languages.selectValue[i]"
                :options="formsData.userForm.languages.options[i]" :searchable="false" :allow-empty="false"
                label="title" :placeholder="'Select one'" track-by="title" :show-labels="false" :id="i"
                :custom-label="customLabel" @select="selectOptions">
                <template #singleLabel="props">
                  <span :class="'flag-icon flag-icon-' + props.option.flag"></span>
                  <span>{{ props.option.title }}</span>
                </template>
                <template #option="props" :class="props.option.show">
                  <span :class="'flag-icon flag-icon-' + props.option.flag"></span>
                  <span>{{ props.option.title }}</span>
                </template>
              </VueMultiselect>
              <el-button type="transparent" @click="removeOption(i)"
                :disabled="!formsData.userForm.languages.remove[i]">
                <i class="el-icon-close"></i>
              </el-button>
            </div>
          </el-form-item>
          <el-form-item class="button_submit mb0">
            <el-button class="submit" type="blue" @click="save('userForm', true)"
              :disabled="formsData.userForm.disabled">
              <span v-if="routeName == 'profile_languages'">Save</span>
              <span v-else>Continue</span>
            </el-button>
          </el-form-item>
        </template>
      </el-form>
     
    </div>
    <div class="background-circles">
        <div class="circle circle-2"></div>
        <div class="circle circle-1"></div>
        <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none" />
      </div>
  </div>

</template>

<script>
import VueMultiselect from "vue-multiselect";

import { onMounted, inject, ref } from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";

import { useStore } from "vuex";

import { useRouter, useRoute } from "vue-router";
import formHooks from "@/hooks/form/form";
import formValidate from "@/hooks/form/validate/validate";
import SvgIcon from '@/components/Svg/SvgIcon.vue';

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    VueMultiselect,
    SvgIcon,
  },
  setup() {
    const $store = useStore();
    const $router = useRouter();
    const $route = useRoute();
    const setPageClassGlobal = inject(["setPageClassGlobal"]);

    const routeName = $route.name;

    const userData = $store.getters.GET_USER_DATA;

    const languages = ref([]);
    const languagesList = $store.getters.getLanguagesList;

    Object.keys(languagesList).forEach((key) => {
      const language = {
        title: languagesList[key],
        desc: key,
        flag: key.split("_")[1] ? key.split("_")[1].toLowerCase() : false,
        show: true,
        $isDisabled: key.split("_")[1] ? false : true,
      };

      languages.value.push(language);
    });

    let stepLanguage = ref(false);

    const formsDataArray = {
      userForm: {
        languages: {
          value: userData.languages || [null],
          selectValue: [null],
          options: [],
          remove: [false],
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "languages",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
      },
    };


    const customLabel = ({ title, desc }) => {
      return `${title} – ${desc}`;
    };

    const selectOptions = (selectedOption, id) => {
      setOption(selectedOption, id);

      formsData.userForm.languages.value[id] = selectedOption.desc;
      checkFormValidation("userForm", true);
    };

    const addEmptyOption = (id, remove) => {
      function addOption(id) {
        formsData.userForm.languages.selectValue.push(null);
        formsData.userForm.languages.options.push(null);
        formsData.userForm.languages.options[id] = languages.value.filter(
          (x) => x.show
        );
      }
      if (remove && languages.value.every((x) => x.show == false)) {
        addOption(id);
      } else if (!remove && languages.value.some((x) => x.show == true)) {
        addOption(id);
      }
    };

    const removeOption = (id) => {
      if (formsData.userForm.languages.selectValue.length > 1) {
        addEmptyOption(formsData.userForm.languages.options.length + 1, true);

        languages.value.some((x) => {
          if (formsData.userForm.languages.selectValue[id].desc == x.desc) {
            x.show = true;
            return true;
          }
        });
        formsData.userForm.languages.options.splice(id, 1);
        formsData.userForm.languages.selectValue.splice(id, 1);
        formsData.userForm.languages.value.splice(id, 1);
      } else {
        languages.value.some((x) => {
          if (formsData.userForm.languages.selectValue[id].desc == x.desc) {
            x.show = true;
            return true;
          }
        });
        formsData.userForm.languages.selectValue[id] = null;
      }
      setOptionsValue();
      checkFormValidation("userForm", true);
    };

    const setOption = (lang, id) => {
      if (lang.desc == "Remove") {
        console.log(id);
      } else if (id !== undefined) {

        languages.value.some((x) => {
          if (lang.desc == x.desc) {
            x.show = false;
            return true;
          }
        });

        if (formsData.userForm.languages.selectValue[id] != null) {
          languages.value.some((x) => {
            if (formsData.userForm.languages.selectValue[id].desc == x.desc) {
              x.show = true;
              return true;
            }
          });
        } else {
          addEmptyOption(id + 1);
        }

        languages.value.some((x) => {
          if (lang.desc == x.desc) {
            x.show = false;
            formsData.userForm.languages.selectValue[id] = lang;
            return true;
          }
        });

        formsData.userForm.languages.options[id] = languages.value.filter(
          (x) => x.show
        );

        if (formsData.userForm.languages.selectValue[id] != null) {
          formsData.userForm.languages.remove.push(true);
        }
      } else {
        lang.forEach((element, i) => {
          languages.value.some((x) => {
            if (element == x.desc) {
              x.show = false;
              if (formsData.userForm.languages.selectValue[i] !== undefined) {
                formsData.userForm.languages.selectValue[i] = x;
              } else {
                formsData.userForm.languages.selectValue.push(x);
              }
              return true;
            }
          });
          formsData.userForm.languages.options[i] = languages.value.filter(
            (x) => x.show
          );
        });

        lang.forEach((element, i) => {
          formsData.userForm.languages.options[i] = languages.value.filter(
            (x) => x.show
          );
          if (formsData.userForm.languages.selectValue[id] != null) {
            formsData.userForm.languages.remove.push(true);
          }
        });

        if (formsData.userForm.languages.value[0] != null) {
          addEmptyOption(formsData.userForm.languages.options.length);
        }
      }

      setOptionsValue();
    };

    const setOptionsValue = () => {
      formsData.userForm.languages.options.forEach((option, i) => {
        formsData.userForm.languages.options[i] = languages.value.filter(
          (x) => x.show
        );
        if (formsData.userForm.languages.selectValue[i] != null) {
          formsData.userForm.languages.remove[i] = true;
        } else {
          formsData.userForm.languages.remove[i] = false;
        }
      });
    };
    const nextStep = () => {
      stepLanguage.value = !stepLanguage.value;
      if (stepLanguage.value) {
        checkFormValidation("userForm", false);
      }
    };

    const goBack = async() => {
      if (stepLanguage.value) {
        stepLanguage.value = !stepLanguage.value;
      } else if (routeName == "profile_languages") {
        $router.push({
          name: "profile_edit",
        });
      } else {
        const back = await $store.dispatch("getAuthPageBack");
        $router.push({
            name: back,
        }); 
      }
    };

    const goNext = () => {
        $router.push({
          name: "onboard_photo",
        });
    };

    const skip = () => {
      $store.dispatch("addAuthPageBack", $route.name);
      goNext();
    };

    const save = (formName, value) => {
      formsRefs[formName].value.validate((valid) => {
        if (valid) {
          (async () => {
            try {
              const data = value
                ? getFormValues(formName)
                : {
                    languages: null,
                  };
              await $store.dispatch("SAVE_USER_DATA", data);
              goNext();
            } catch (error) {
              console.log("error submit!!");
            }
          })();
        } else {
          setFormValidation(formName, false, false);
          console.log("error submit!!");
          return false;
        }
      });
    };

    onMounted(() => {
      setPageClassGlobal("global_onboard_internal_page global_user_languages_page");
      setFormRefs();
      setOption(formsData.userForm.languages.value);
    });

    const {
      checkFormValidation,
      setFormValidation,
      getFormValues,
      setFormRefs,
      formsData,
      formsRefs,
    } = formHooks(formsDataArray);

    return {
      formsData,
      goBack,
      save,
      skip,
      stepLanguage,
      selectOptions,
      customLabel,
      removeOption,
      nextStep,
      routeName,
    };
  },
};
</script>
